module.exports = __webpack_public_path__ + "static/media/ic_valued_yellow.c6cfa932.svg";